import {Injectable, OnDestroy} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable, Subject} from 'rxjs';
import {ProjectService} from '../services/project.service';
import {takeUntil} from 'rxjs/operators';
import {CmsService} from '../../cms/services/cms.service';
import { UrlSites } from 'src/app/enums/url-sites.enum';

@Injectable({
  providedIn: 'root'
})
export class NewsletterGuard implements CanActivate, OnDestroy {

  constructor(private _projectService: ProjectService,
              private _cmsService: CmsService) {
  }

  private unsubscribe$ = new Subject<any>();

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let activate = false;
    this._cmsService.siteUrl$.pipe(takeUntil(this.unsubscribe$)).subscribe(siteUrl => {
      if (siteUrl) {
        if (siteUrl.includes(UrlSites.GEOTN) || siteUrl.includes(UrlSites.VACANZEWELCOMETRAVEL)) {
          activate = true;
        }
      }
    });
    return activate || this._projectService.hasNewsletter();

  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }
}
